import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IParamsAlert, IAlertList } from '~/utils/interface/alert';
import { handleGetAlertList } from './alertThunk';
import { SortDirectionEnum } from '~/utils/enum';
import { PAGE_INDEX, PAGE_SIZE } from '~/utils/constants/common';

export interface AdminAlertState {
  alerts: IAlertList[];
  filter: IParamsAlert;
  totalItems: number;
  needRefreshData: boolean;
}

const initialState: AdminAlertState = {
  alerts: [],
  totalItems: 0,
  needRefreshData: false,
  filter: {
    username: '',
    searchBy: '',
    search: '',
    sortBy: '',
    startDate: '',
    endDate: '',
    level: undefined,
    status: undefined,
    sortOrder: SortDirectionEnum.DESC,
    pageIndex: PAGE_INDEX,
    pageSize: PAGE_SIZE,
  },
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IParamsAlert>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetFilter: (state) => {
      state.filter = initialState.filter;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetAlertList.pending, (_state, _action) => {})
      .addCase(handleGetAlertList.fulfilled, (state, action) => {
        const data = action.payload?.result?.data;
        state.alerts = Array.isArray(data) ? data : [];
        state.totalItems = action.payload.result.total_record || 0;
        state.needRefreshData = false;
      })
      .addCase(handleGetAlertList.rejected, (_state, _action) => {});
  },
});

export const alertActions = alertSlice.actions;

const alertReducer = alertSlice.reducer;
export default alertReducer;
